const NotFoundPage = () => {
    return <>
        <h1 className="flex h-screen items-center justify-center">Not Found</h1>
    </>
}

export default NotFoundPage